import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { PostingType } from 'app/library/posting/models/posting-type.model';
import { ICourseOfferingLandingPageQuery } from '../interfaces/course-offering-landing-page.query.interface';

// @dynamic
export class CourseOfferingLandingPage {
    id: string;
    courseOffering: {
        id: string;
    };
    status: string;
    shortDescription: string;
    description: string;
    title: string;
    language: string;
    image: MaxbrainImage;
    postingType: PostingType;

    constructor(query: ICourseOfferingLandingPageQuery) {
        this.id = query.id.toString();
        this.courseOffering = {
            id: query.course_offering.id.toString(),
        };
        this.status = query.status;
        this.title = query.title;
        this.language = query.language;
        this.description = query.description;
        this.shortDescription = query.short_description;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.postingType = new PostingType(query.posting_type);
    }
}
